import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { useUserSession } from '../../../../../models/hooks/appStateHooks';
import donorPerfectLogo from '../../../../assets/logo_donorperfect_sm.png';
import { white } from '../../../../styles/colors';
import { baseStyleSheet } from '../../../../styles/styles';
import { DonorPerfectIntegrationGraphic } from '../../../svgs/graphics/DonorPerfectIntegrationGraphic';
import { IntegrationCard, useIntegrationCard } from '../IntegrationCard';
import { styleSheet } from './styles';

export const DashboardDonorPerfectV2IntegrationCard = () => {
	const userSession = useUserSession();
	const { getLogoImgProps, getCloseButtonProps, getCtaButtonProps, getIntegrationTitleProps, showCard } =
		useIntegrationCard({
			closeIntegrationEventName: 'DonorPerfectV2IntegrationClosed',
			enableUrlPath: `/integrations/${Api.IntegrationProvider.DonorPerfect}`,
			integrationEnableEventName: 'DonorPerfectV2IntegrationEnableClick',
			pendingAction: Api.PendingActions.ConnectDonorPerfectV2,
		});

	// Admin-only, because only an admin can enter V2's single account-level API key.
	if (!showCard || !userSession.isAdmin) {
		return null;
	}

	return (
		<IntegrationCard
			closeButtonProps={getCloseButtonProps()}
			IntegrationGraphic={DonorPerfectIntegrationGraphic}
			headerLabel='DonorPerfect Integration (V2)'
			logoBgColor={white}
			logoImgProps={getLogoImgProps({
				alt: 'DonorPerfect Logo',
				className: css(styleSheet.logo),
				src: donorPerfectLogo,
			})}
			ctaButtonProps={getCtaButtonProps({
				children: 'Connect with DonorPerfect V2',
				styleDeclaration: [baseStyleSheet.ctaButtonReverse, styleSheet.ctaButton],
			})}
			integrationTitleProps={getIntegrationTitleProps({
				styleDeclaration: styleSheet.integrationTitle,
			})}
		>
			<p>Enhanced Integration Available!</p>
			<p>
				We are excited to announce that you can integrate your DonorPerfect account with Levitate using our new V2
				integration. With this enhanced integration, we will have the ability to pull donor information, including
				names, email, phone number, birthdays, gift history, and more &mdash; making staying in touch even easier.
			</p>
		</IntegrationCard>
	);
};
